import { scrollToTop } from "@/lib/scroll";

const Logo = ({ dark = false }) => (
  <a
    href="#top"
    data-testid="logo-link"
    onClick={(e) => {
      e.preventDefault();
      scrollToTop();
    }}
    className="flex items-center"
    aria-label="Sell With Abhi — back to top"
  >
    <span
      className={`font-serif text-xl font-semibold tracking-tight ${
        dark ? "text-cream" : "text-ink"
      }`}
    >
      Sell With Abhi
    </span>
  </a>
);

export default Logo;
